export const VALID_CODE_LENGTH = 6;

export const isNumericOrBlank = (value: string) => {
  return !isNaN(parseFloat(value)) || value === "";
};

export const isNumericOrBlankCode = (code: string): boolean => {
  return Array.from(code).every((slot) => isNumericOrBlank(slot));
};
